"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
/* eslint-disable */

/* @copyright github/tur-nr */


var _default = function _default(bindTo) {
  var stack = [];

  var use = function use() {
    for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    var i = fns.length;

    while (i--) {
      var fn = fns[i];
      if (Array.isArray(fn)) return use.apply(void 0, (0, _toConsumableArray2["default"])(fn));
      if ('function' === typeof fn) stack.unshift(fn);
    }
  };

  var run = function run(done) {
    var i = stack.length;

    var next = function next() {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var fin = arguments.length > 1 ? arguments[1] : undefined;

      if (err || fin || !i) {
        if ('function' === typeof done) done(err);
        return;
      }

      var mw = stack[--i];
      if (mw && typeof mw.apply !== 'undefined') mw.call(bindTo, next);
    };

    next();
  };

  var getCount = function getCount() {
    return stack.length;
  };

  return {
    use: use,
    run: run,
    getCount: getCount
  };
};

exports["default"] = _default;